export const workflowTypes = {
    TRIKO: 1,
    CLIENT: 2,
    REQUIRED_DOCUMENTATION: 3,
    SERVICES: 4,
    ORDERS: 5,
    FAVOR: 7,
    TRIKO_SERVICES: 8
}
